module.exports = __webpack_public_path__ + "img/logo-full.6bb11153.png";